import React from 'react';
import { calculateAuditDuration, fmtStoreCheck } from '../../../../utils/timeUtils';

/**
 * Builds the ordered route rows (audit label, store name, minutes in store) from the
 * promoter's store checks for the selected period.
 */
export function useRouteInfo(storeChecks, stores) {
    const [info, setInfo] = React.useState([]);

    // Sorting function with safety check
    const sortedItems = storeChecks
        ? (storeChecks || []).sort((a, b) => {
              return new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
          })
        : [];

    const getInfo = () => {
        if (!sortedItems || sortedItems.length === 0) {
            setInfo([]);
            return;
        }

        Promise.all(
            sortedItems.map(async (storeCheck, index) => {
                const store = stores?.find((st) => st._id === storeCheck.storeId);

                // Use shared utility for time calculation (business logic in utils)
                const differenceInMinutes = calculateAuditDuration(storeCheck);

                return {
                    key: storeCheck._id || index,
                    _id: storeCheck._id,
                    auditName: `Auditoría ${fmtStoreCheck(storeCheck.createdAt, 'h:mm A')}`,
                    storeName: store?.name || 'Tienda no encontrada',
                    timeInStore: differenceInMinutes,
                    createdAt: storeCheck.createdAt
                };
            })
        )
            .then((res) => {
                setInfo(res);
            })
            .catch((error) => {
                console.warn('Error processing store checks:', error);
                setInfo([]);
            });
    };

    React.useEffect(() => {
        getInfo();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storeChecks]);

    return info;
}
